import { logger } from '../logging/logger'
import type { DepositClientMetadata } from './depositFlowConfig'
import { FunkitMisconfiguredError } from './flowError'

/**
 * Preserve identifier validation's existing drop-and-warn behavior, but never
 * silently remove a supplied deposit ceiling.
 */
export function validateClientMetadata(
  clientMetadata: DepositClientMetadata | undefined,
): DepositClientMetadata | undefined {
  if (!clientMetadata) {
    return undefined
  }

  const { externalUserId, clientTransactionId, authorizedAmountBaseUnit } =
    clientMetadata
  const result: DepositClientMetadata = {}

  if (authorizedAmountBaseUnit !== undefined) {
    if (
      typeof authorizedAmountBaseUnit !== 'string' ||
      !/^[1-9][0-9]{0,29}$/.test(authorizedAmountBaseUnit)
    ) {
      throw new FunkitMisconfiguredError(
        'clientMetadata.authorizedAmountBaseUnit must be a positive integer string of at most 30 digits without leading zeros',
      )
    }
    result.authorizedAmountBaseUnit = authorizedAmountBaseUnit
  }

  if (externalUserId !== undefined) {
    if (typeof externalUserId === 'string' && externalUserId.length > 0) {
      result.externalUserId = externalUserId
    } else {
      logger.warn('connect-rn:deposit:invalid_client_metadata', {
        field: 'externalUserId',
        value: externalUserId,
      })
    }
  }

  if (clientTransactionId !== undefined) {
    const parsed = Number(clientTransactionId)
    if (
      typeof clientTransactionId === 'string' &&
      /^\d+$/.test(clientTransactionId) &&
      Number.isSafeInteger(parsed) &&
      parsed > 0
    ) {
      result.clientTransactionId = clientTransactionId
    } else {
      logger.warn('connect-rn:deposit:invalid_client_metadata', {
        field: 'clientTransactionId',
        value: clientTransactionId,
      })
    }
  }

  return Object.keys(result).length > 0 ? result : undefined
}
